
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { WizardStep } from "../../../../interfaces/dynamicForms/Forms";
import { getIcon } from "./utils";

interface StepBarProps {
  steps: WizardStep[];
  currentStepIndex: number;
  errors: Record<string, string>;
  onStepClick?: (idx: number) => void;
}

export function VerticalStepBar({
  steps,
  currentStepIndex,
  errors,
  onStepClick,
}: StepBarProps) {
  return (
    <>
      {/* Single vertical timeline line */}
      {steps.map((step, idx) => {
        const isActive = idx === currentStepIndex;
        const stepHasError = step.questions.some((q) => errors[q.id]);
        const isCompleted = idx < currentStepIndex && !stepHasError;

        return (
          <div
            key={step.label}
            className="stepper_count"
            onClick={() => onStepClick?.(idx)}
          >
            {/* Icon bubble */}
            <div
              className={`
                                w-10 h-10 rounded-full flex items-center justify-center transition-colors
                                ${
                                  isCompleted
                                    ? "bg-[#198754]" // Blue for completed (secondary accent)
                                    : isActive
                                    ? "bg-[#7E57C2]" // Green for active (primary accent)
                                    : "bg-gray-500" // Light gray for inactive
                                }
                                ${stepHasError ? "ring-2 ring-red-500" : ""}
                                `}
            >
              <FontAwesomeIcon
                icon={getIcon(step.icon ? step.icon : "")}
                className="text-white w-4 h-4"
              />
            </div>
            {/* Left text block */}
            <div className="stepper_text">
              <h4>{step.label}</h4>
              <p>{isCompleted ? "Completed" : "Pending"}</p>
            </div>
          </div>
        );
      })}
    </>
  );
}
